const reloadPage = (e) => {
    // console.log(e)
    window.location.reload()
    return
}

export { reloadPage }